export enum CmsLocaleEnum {
  EN_US = 1,
  ES_MX = 2,
}

export const CmsLocaleDisplayNames = {
  [CmsLocaleEnum.EN_US]: 'English (US)',
  [CmsLocaleEnum.ES_MX]: 'Spanish (Mexico)',
};
